import { VFC, useEffect, useState } from 'react'
import { Asset, AssetReference } from '@opallabs/cassini'
import { useTheme } from '@opallabs/hooks'
import { Icon } from '@opallabs/lapidary'
import { Modal } from '@opallabs/satellite'
import { useTextEditor, type TextEditorAsset } from '@opallabs/text-editor'
import * as styles from './styles'

type AssetModalProps = {
  expandedAsset: TextEditorAsset | null
  onClose: () => void
}

export const AssetModal: VFC<AssetModalProps> = ({
  expandedAsset,
  onClose,
}) => {
  const theme = useTheme()
  const { editor } = useTextEditor()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible((prevState) => {
      // Focus the editor when the modal is closed
      if (prevState && expandedAsset === null) {
        editor.commands.focus()
      }

      return expandedAsset !== null
    })
  }, [editor, expandedAsset])

  return (
    <Modal onClose={onClose} visible={isVisible && expandedAsset !== null}>
      {isVisible && expandedAsset !== null && (
        <div css={styles.modal}>
          <Asset
            assetReference={{
              uuid: expandedAsset.assetUuid ?? undefined,
              asset_type: (expandedAsset.assetType ??
                undefined) as AssetReference['asset_type'],
              filename: expandedAsset.filename ?? undefined,
              width: expandedAsset.width ?? undefined,
              height: expandedAsset.height ?? undefined,
            }}
          />
          <button css={styles.closeButton({ theme })} onClick={onClose}>
            <span className="sr-only">Exit modal</span>
            <Icon aria-hidden={true} glyph="gem-close" />
          </button>
        </div>
      )}
    </Modal>
  )
}
